export default __webpack_public_path__ + "static/little-pony-10952f20371d83f7cd9608acc1768587.svg";